import i18n from '../../../i18n';
import React from 'react';

export const ENV_META = {
  prod: { label: i18n.t('auto.lbl.production'), color: 'bg-red-600 text-white', border: 'border-red-300 bg-red-50' },
  demo: { label: i18n.t('auto.lbl.demo'), color: 'bg-amber-500 text-white', border: 'border-amber-300 bg-amber-50' },
  test: { label: i18n.t('auto.lbl.test'), color: 'bg-slate-500 text-white', border: 'border-slate-300 bg-slate-50' },
};

export const EnvBadge = ({ env, small }) => {
  const m = ENV_META[env] || ENV_META.test;
  return (
    <span className={`inline-block text-xs font-bold px-2 py-0.5 rounded ${m.color} ${small ? 'text-[10px]' : ''}`}>
      {m.label}
    </span>
  );
};

export const PermBadge = ({ perms }) => (
  <span className="inline-flex gap-1">
    {(perms || []).map(p => (
      <span key={p} className="text-[10px] font-medium px-1.5 py-0.5 rounded bg-blue-100 text-blue-700">{p}</span>
    ))}
  </span>
);

export const fmtAmt = (v, cur = 'PLN') => v != null ? `${Number(v).toFixed(2)} ${cur}` : '—';
export const fmtDate = s => s ? s.slice(0, 10) : '—';
